import { Button } from 'common/components/Button/Button'
import { Input } from 'common/components/Forms/Inputs/Input'
import { errorMessages } from 'common/utils/validation/messages'
import { Form, Formik } from 'formik'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import useSWRMutation from 'swr/mutation'
import * as Yup from 'yup'
import { ApiPathsUsers, sendPassword } from '../auth.service'

export const ForgotPassComponent = () => {
  //utils
  const router = useRouter()
  const { trigger, isMutating } = useSWRMutation(ApiPathsUsers.passwordSend, sendPassword)

  //state
  const initialForgotPassState = {
    email: '',
  }
  const ForgotPassSchema = Yup.object().shape({
    email: Yup.string()
      .required(errorMessages.isRequired)
      .email(errorMessages.isEmail)
      .max(50, errorMessages.maxLength),
  })

  const triggerCallback = (email: string) => {
    router.push(`/forgot-password?email=${encodeURIComponent(email)}`)
    toast.success(
      "Please check your email for password reset instructions. If you don't receive an email, kindly review your spam folder and ensure your registration email matches.",
    )
  }
  //handlers
  const handleSubmit = async (values: { email: string }) => {
    await trigger(values, {
      onSuccess: () => triggerCallback(values.email),
      onError: () => triggerCallback(values.email),
    })
  }

  return (
    <Formik onSubmit={handleSubmit} initialValues={initialForgotPassState} validationSchema={ForgotPassSchema}>
      {({ setFieldValue, values, errors, touched, setFieldTouched }) => {
        const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          setFieldTouched(e.target.name, false)
          setFieldValue(e.target.name, e.target.value)
        }
        return (
          <Form className="px-4 sm:px-0">
            <TextContainer>
              <h3>Forgot your password?</h3>
              <p>No stress, enter your email and we’ll send you instructions.</p>
            </TextContainer>
            <Input
              name="email"
              label="Email"
              placeholder="Type here"
              value={values?.email}
              onChange={onChange}
              error={touched?.email && errors?.email}
            />
            <Button isLoading={isMutating} type="submit" size="large" className="w-full my-5">
              Send instructions
            </Button>

            <TextContainer>
              <p className="footerText">
                <Link className="secondary_100" href="/login">
                  Back to login page
                </Link>
              </p>
            </TextContainer>
          </Form>
        )
      }}
    </Formik>
  )
}

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  h3 {
    font-weight: 600;
    font-size: 22px;
    line-height: 140%;
    margin-bottom: 0.5rem;
  }
  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 180%;
  }
  .footerText {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 180%;
  }
  margin-bottom: 2rem;
`
